export default {
    getResourceListByFuncId: '/auth/function/functionResource', //根据职能包获取资源列表
    bindFunctionalResource: '/auth/function/functionResourceBinding', //根据职能包获取资源列表
  };
  


// WEBPACK FOOTER //
// ./src/api/configFuntional.js